/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ReportDefs from './defs.defs.js'

const $nsid = 'tools.ozone.report.queryReports'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  queueId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  reportTypes: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  status: /*#__PURE__*/ l.string<{
    knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
  }>(),
  subject: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  subjectType: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['account', 'record'] }>(),
  ),
  collections: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' }), {
      maxLength: 20,
    }),
  ),
  reportedAfter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  reportedBefore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  isMuted: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
  ),
  assignedTo: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
  sortField: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.enum(['createdAt', 'updatedAt']),
      'createdAt',
    ),
  ),
  sortDirection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.enum(['asc', 'desc']), 'desc'),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reports: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ReportDefs.ReportView>(
      (() => ReportDefs.reportView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** View moderation reports. Reports are individual instances of content being reported, as opposed to subject statuses which aggregate reports at the subject level. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
